import React from 'react'
import {
  Card,
  Wrapper,
  Header,
  Avatar,
  InfoBlock,
  StatsCard,
  StatRow,
  ColLabel,
  ColValueMain,
  ColValuePrev,
  ButtonPrimary,
  LogoutButton,
  FooterActions,
  LastNameText,
  NameText,
} from './index.styled'
import { useDoctorProfile } from './useDoctorProfile'
import { RootState, useAppSelector } from '../../../redux/store'

export default function ProfileStats() {
  const { clearAllTokens, pageRefresh, formatPhoneNumber, isRefreshDisabled } = useDoctorProfile()
  const doctor = useAppSelector((state: RootState) => state.doctorAuth.doctor)
  return (
    <Wrapper>
      <Card>
        <Header>
          <Avatar src={doctor?.user?.profilePic} />
          <InfoBlock>
            <NameText>{doctor?.user?.firstname?.toUpperCase() || ''}</NameText>
            <LastNameText>{doctor?.user?.lastname?.toUpperCase() || ''}</LastNameText>
            <p>{doctor?.user?.email}</p>
            <p>{formatPhoneNumber(doctor?.user?.phone) || ''}</p>
          </InfoBlock>
        </Header>

        {/* <StatsCard>
          <StatRow>
            <ColLabel>Rating</ColLabel>
            <ColValueMain>9.8</ColValueMain>
            <ColValuePrev>9.5</ColValuePrev>
          </StatRow>

          <StatRow>
            <ColLabel>Adjustments</ColLabel>
            <ColValueMain>124</ColValueMain>
            <ColValuePrev></ColValuePrev>
          </StatRow>

          <StatRow>
            <ColLabel>New Patients</ColLabel>
            <ColValueMain>56</ColValueMain>
            <ColValuePrev></ColValuePrev>
          </StatRow>

          <StatRow>
            <ColLabel>Conversion</ColLabel>
            <ColValueMain>23</ColValueMain>
            <ColValuePrev>
              <span style={{ color: '#E57373' }}>46%</span>
              <span style={{ color: '#4CAF50' }}>32%</span>
            </ColValuePrev>
          </StatRow>

          <StatRow>
            <ColLabel>Retention</ColLabel>
            <ColValueMain>18</ColValueMain>
            <ColValuePrev>
              <span style={{ color: '#E57373' }}>84%</span>
              <span style={{ color: '#4CAF50' }}>91%</span>
            </ColValuePrev>
          </StatRow>
        </StatsCard> */}

        <FooterActions>
          <ButtonPrimary $disabled={isRefreshDisabled} onClick={() => pageRefresh()}>
            Refresh
          </ButtonPrimary>
          <LogoutButton onClick={() => clearAllTokens()}>Logout</LogoutButton>
        </FooterActions>
      </Card>
    </Wrapper>
  )
}
